export enum MedicationSource {
    MedicationDefinition = 1,
    MedicationProduct = 2
}